import script from "./AddressInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressInput.vue?vue&type=script&setup=true&lang=ts"

import "./AddressInput.vue?vue&type=style&index=0&id=5c74b4bc&scoped=true&lang=css"
import "@/assets/css/address2.css?vue&type=style&index=1&id=5c74b4bc&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c74b4bc"]])

export default __exports__